export enum NotificationTypes {
  DEFAULT = "DEFAULT",
  TIMETRACK_OUT_OF_RANGE = "TIMETRACK_OUT_OF_RANGE",
  UNCOMPLETED_TASK = "UNCOMPLETED_TASK",
  NEW_TASK_DETAIL = "NEW_TASK_DETAIL",
  TASK_UPDATED_BY_WORKER = "TASK_UPDATED_BY_WORKER",
  NEW_COMMENT = "NEW_COMMENT",
  OVERDUE_INVOICE = "OVERDUE_INVOICE",
  OVERDUE_QUOTE = "OVERDUE_QUOTE",
  UNSIGNED_DELIVERY_NOTE = "UNSIGNED_DELIVERY_NOTE",
  NEW_TASK_REQUEST = "NEW_TASK_REQUEST"
}